import axios from "axios";
import store from "@/store";
import localApi from "@/util/localApi.js";

export default {
  install(Vue) {
    // Internacionalization Language
    let language = localStorage.getItem("language") || "pt";

    // Internacionalization GMT
    let gmt = new Date();
    gmt.getTimezoneOffset() / 60;
    let sub = String(gmt);
    sub = sub.slice(28, 31) + ":" + sub.slice(31, 33);

    let hostName = window.location.hostname;

    let host =
      hostName.split(".")[0] == "www"
        ? hostName.split(".")[1]
        : hostName.split(".")[0];

    let baseURL = "";

    const agentOnDev = host == "agent" && hostName.split(".")[1] == "sys";
    const local = host == "localhost" || host == "192";

    const homologs = [
      "homolog-user",
      "homolog-agent",
      "homolog-user-newcasino",
      "homolog-api",
    ];

    if (host == "sys" || host == "casino" || local || agentOnDev) {
      baseURL = localApi() || "https://apidev.sga.bet";
      // baseURL = "https://v2.envrelease.com";
    } else if (homologs.includes(host)) {
      baseURL = "https://apiv2dev.sga.bet";
    } else {
      baseURL = "https://v2.envrelease.com";
    }

    // Config
    Vue.prototype.$axios = axios.create({
      baseURL,
      headers: {
        "Content-Type": "multipart/form-data",
        "x-api-key": "02ff96c8f50ce6a488812146d448a04b2e2358dd45d0dbb59824",
        language: language,
        gmt: sub,
      },
    });

    const refreshToken = () => {
      if (!store.state.logged.status) {
        return;
      }

      if (Vue.prototype.$isAgent()) {
        return;
      }

      const now = new Date();
      const expirationDate = new Date(
        JSON.parse(localStorage.getItem("tokenExpirationDate"))
      );

      const difference = expirationDate.getTime() - now.getTime();
      const differenceInMinutes = Math.round(difference / 60000);
      const lessThanFiveMinutesOfToken = 5 > differenceInMinutes > 0;

      if (lessThanFiveMinutesOfToken) {
        clearTimeout(JSON.parse(localStorage.getItem("refreshId")));

        const refreshId = setTimeout(() => {
          fetch(`${baseURL}/player/token/refresh`, {
            method: "POST",
            headers: {
              "Application-Authorization":
                Vue.prototype.$axios.defaults.headers.common[
                  "Application-Authorization"
                ],
              "x-api-key":
                "02ff96c8f50ce6a488812146d448a04b2e2358dd45d0dbb59824",
            },
          })
            .then((res) => res.json())
            .then((data) => {
              Vue.prototype.$axios.defaults.headers.common[
                "Application-Authorization"
              ] = data.dados.token;

              store.commit("setLogged", {
                ...store.state.logged,
                token: data.dados.token,
              });

              const date = data.dados.token_exp.replace(/-/g, "/");
              localStorage.setItem("tokenExpirationDate", JSON.stringify(date));
            })
            .catch(() => {
              Vue.prototype.$logout();
            });
        }, 2000);

        localStorage.setItem("refreshId", JSON.stringify(refreshId));
      }
    };

    // Interceptors
    Vue.prototype.$axios.interceptors.response.use(
      function(response) {
        refreshToken();

        store.commit("resetCounterOfErrors500");

        store.commit("setFeedbackProgress", false);
        store.commit("setProgressLinear", false);
        store.commit("setSave", false);
        store.commit("DisabledSave", false);
        return response;
      },
      function(error) {
        // Erro 500
        if (error.response.status == 500) {
          store.commit("setCounterOfErrors500");

          store.commit("setFeedbackSnack", {
            msg: error.response.data.messages.messages,
            color: "warning",
          });
        }

        // Erro 401 - Token Expired
        if (error.response.status === 401) {
          store.commit("resetCounterOfErrors500");

          store.commit("setNotification", {
            msg: error.response.data.messages.error,
            color: "warning",
          });
          Vue.prototype.$logout();
        }

        // Erro 400 - No data, Alert Snack (Temporário)
        if (error.response.status === 400 && Vue.prototype.$isAgent()) {
          store.commit("resetCounterOfErrors500");

          if (error.response.data.messages) {
            store.commit("setNotification", {
              msg: error.response.data.messages.error,
              color: "warning",
            });
          }
        }

        // Erro 403 - Validar Aposta
        if (error.response.status === 403 && Vue.prototype.$isAgent()) {
          store.commit("resetCounterOfErrors500");

          store.commit("setFeedbackSnack", {
            msg: error.response.data.messages.messages,
            color: "warning",
          });
        }

        // Erro 400 - Bloqueio do jogador
        //? Abertura de dialog informando o motivo
        if (
          error.response.status === 400 &&
          error.response.data.dados &&
          error.response.data.dados.block_type &&
          !Vue.prototype.$isAgent()
        ) {
          store.commit("setDialogBlockUser", {
            status: true,
            idReason: error.response.data.dados.block_type,
            messageReason: error.response.data.dados.block_reason,
          });
        }

        if (
          (error.response.status === 400 || error.response.status === 403) &&
          !Vue.prototype.$isAgent()
        ) {
          refreshToken();
        }

        store.commit("setFeedbackProgress", false);
        store.commit("setProgressLinear", false);
        store.commit("setSave", false);
        store.commit("DisabledSave", false);
        return Promise.reject(error);
      }
    );
  },
};
